'use strict';
import React from 'react';

import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { APPOINTMENTS } from '../../../data/reducer';
import Alert from '../../Alert';
import NotificationWithIcon from '../../NotificationWithIcon';
import { getTime } from '../../../utils/TimeUtils';
import Span from '../../tag/Span';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';

let { id: module_id } = module;

class QueueAppointments extends React.Component {
  render() {
    let { data, error, showPlaceholder } = this.props;

    const removeAbbreviationFromUnit = (unitName) => {
      return unitName ? unitName.replace(/ \(.*\)/, '') : unitName;
    }

    if (showPlaceholder) {
      return null;
    }

    let other = null;

    if (error) {
      other = <Alert message={`${module_id}.${error.code}`} />;
    } else if (isEmpty(data)) {
      other = (
        <p>
          <FormattedMessage id={`${module_id}.no.reservable.appointments`} />
        </p>
      );
    }

    return (
      <div>
        {other || (
          <ul className="appointment-container">
            {data &&
              data.map((queueAppointment) => (
                <NotificationWithIcon
                  key={queueAppointment.appointmentId}
                  titleIntl={{ id: `${module_id}.title` }}
                  icon={{ type: 'fa', name: 'icon-calendar' }}
                  description={
                    <FormattedMessage
                      id={`${module_id}.description`}
                      values={{
                        unitName: removeAbbreviationFromUnit(queueAppointment.location),
                        queueStartDate: getTime(
                          queueAppointment.dateStart
                        ).format('D.M.'),
                        queueEndDate: getTime(queueAppointment.dateEnd).format(
                          'D.M.yyyy'
                        ),
                      }}
                    />
                  }
                  actions={
                    <Span len="6">
                      <OTButtonGroup fullWidth type="big">
                        <OTButton
                          onClick={() =>
                            this.props.history.push(
                              `/appointments/fromQueue/${queueAppointment.appointmentId}`
                            )
                          }
                        >
                          <FormattedMessage id={`reserve.appointment`} />
                        </OTButton>
                      </OTButtonGroup>
                    </Span>
                  }
                />
              ))}
          </ul>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { isFetching, lastFetch, data, error } =
    state[APPOINTMENTS].queueAppointments;

  return {
    isFetching,
    lastFetch,
    data,
    error,
  };
};

export default withRouter(connect(mapStateToProps)(QueueAppointments));
